;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/error-test\",\"regex\":\"^/([^/]+)/error-test$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/revalidate\",\"regex\":\"^/([^/]+)/revalidate$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:customerCompanyNumber\",\"regex\":\"^/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"customerCompanyNumber\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:customerCompanyNumber/:postOfferId\",\"regex\":\"^/([^/]+)/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"customerCompanyNumber\",\"postOfferId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:customerCompanyNumber/:postOfferId/apply\",\"regex\":\"^/([^/]+)/([^/]+)/([^/]+)/apply$\",\"paramNames\":[\"locale\",\"customerCompanyNumber\",\"postOfferId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:customerCompanyNumber/:postOfferId/apply/success\",\"regex\":\"^/([^/]+)/([^/]+)/([^/]+)/apply/success$\",\"paramNames\":[\"locale\",\"customerCompanyNumber\",\"postOfferId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:customerCompanyNumber/loading\",\"regex\":\"^/([^/]+)/([^/]+)/loading$\",\"paramNames\":[\"locale\",\"customerCompanyNumber\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[\"/:locale\"]}";globalThis["_sentryNextJsVersion"] = "16.3.8";globalThis["_sentryRewritesTunnelPath"] = "/api/monitoring";import { captureException, captureRouterTransitionStart, isSentryEnabled, loadSentry } from './util/sentryClient';

/**
 * Mit @sentry/nextjs 10 und Turbopack wird nur diese Datei geladen, die fruehere
 * sentry.client.config.ts lief nie: bis 2026-09-30 kam kein einziger Browser-Fehler in Sentry an.
 *
 * Das SDK wird erst nach dem load-Event im Idle-Callback geladen (FE-4984). Bis dahin fangen die
 * beiden Listener unbehandelte Fehler ab und reichen sie an die Queue in util/sentryClient weiter;
 * der erste Fehler loest das Laden sofort aus. Nach der Initialisierung uebernimmt Sentry mit
 * seinen eigenen globalen Handlern, die Listener werden entfernt.
 */
const onError = (event: ErrorEvent) => {
  if (event.error instanceof Error) captureException(event.error);
};

const onUnhandledRejection = (event: PromiseRejectionEvent) => {
  if (event.reason instanceof Error) captureException(event.reason);
};

const removeListeners = () => {
  window.removeEventListener('error', onError);
  window.removeEventListener('unhandledrejection', onUnhandledRejection);
};

const scheduleLoad = () => {
  const load = () => void loadSentry().then(removeListeners);
  const whenIdle = () =>
    'requestIdleCallback' in window
      ? window.requestIdleCallback(load, { timeout: 5000 })
      : window.setTimeout(load, 2000);

  if (document.readyState === 'complete') {
    whenIdle();
  } else {
    window.addEventListener('load', whenIdle, { once: true });
  }
};

if (typeof window !== 'undefined' && isSentryEnabled()) {
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);
  scheduleLoad();
}

export const onRouterTransitionStart = captureRouterTransitionStart;
